import $ from 'jquery';
import { setCursorRadius } from '~core';
import { modifyState } from '../state';

export const eraserPreviewSlider = () => {
  const eraserSize = $('#editor-object-eraser-slider').val();

  $('.eraser-preview').css({
    width: `${eraserSize}px`,
    height: `${eraserSize}px`,
  });

  modifyState('eraserRadius', eraserSize * 2);

  window.canvas.freeDrawingBrush.width = eraserSize * 2;

  setCursorRadius(eraserSize);
};

export const undoEraser = () => {
  if (window.canvas.freeDrawingBrush.inverted) {
    window.canvas.freeDrawingBrush.inverted = false;
    $('#editor-menu-undo-eraser')
      .text('Ripristina zona cancellata')
      .addClass('btn-secondary')
      .removeClass('btn-warning');
  } else {
    window.canvas.freeDrawingBrush.inverted = true;
    $('#editor-menu-undo-eraser')
      .text('Cancella usando la gomma')
      .addClass('btn-warning')
      .removeClass('btn-secondary');
  }
};
